<template>
  <v-container fluid class="pa-0">
    <div>
      <h2 class="mb-5">{{ $store.getters.t('대시보드') }}</h2>
    </div>

    <DashboardHeader />

    <v-row class="mt-4">
      <DashboardUserInfo />
      <DashboardUsageInfo />
    </v-row>

    <DashboardRouteCard />

  </v-container>
</template>

<script>
import DashboardHeader from './DashboardHeader.vue';
import DashboardRouteCard from './DashboardRouteCard.vue';
import DashboardUsageInfo from './DashboardUsageInfo.vue';
import DashboardUserInfo from './DashboardUserInfo.vue';

export default {
  name: "DashboardForm",
  components: {
    DashboardHeader,
    DashboardUsageInfo,
    DashboardUserInfo,
    DashboardRouteCard,
    
  }

}
</script>

<style lang="scss" scoped>
.dash_main_banner_card{
    padding: 34px;
    border-radius: 10px;
    background-color: #ffffff;
}
.table_title{
    width: 30%;
    font-size: 16px;
    background-color: #F8F8F8;
    border-bottom: 1px solid #DFDFDF;
}

.table_text{
    border-bottom: 1px solid #DFDFDF;
}
</style>